// extracted by mini-css-extract-plugin
export var required = "_pv-0";